"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneralService = void 0;
var Helper_1 = require("./Helper");
var GeneralService = /** @class */ (function () {
    function GeneralService(lineHandling, nomination, activityLogs, workPackets) {
        this.activityLogs = [];
        this.workPackets = [];
        this.lineHandling = lineHandling;
        this.nomination = nomination;
        if (activityLogs) {
            this.activityLogs = activityLogs;
        }
        if (workPackets) {
            this.workPackets = workPackets;
        }
    }
    Object.defineProperty(GeneralService.prototype, "nominations", {
        get: function () {
            var _a;
            return (_a = this.lineHandling) === null || _a === void 0 ? void 0 : _a.nominations;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GeneralService.prototype, "activities", {
        get: function () {
            return this.activityLogs;
        },
        enumerable: false,
        configurable: true
    });
    GeneralService.prototype.setActiveNomination = function (nomNo) {
        var _a;
        if (nomNo) {
            var nom = (_a = this.lineHandling) === null || _a === void 0 ? void 0 : _a.nominations.find(function (f) { return f.nominationNo === nomNo; });
            this.nomination = nom;
        }
        else {
            this.nomination = undefined;
        }
    };
    GeneralService.prototype.updateWPValues = function (wpValue) {
        var previous = this.workPackets.find(function (f) { return f.fieldName === wpValue.fieldName; });
        if (previous) {
            this.workPackets = __spreadArray(__spreadArray([], this.workPackets.filter(function (f) { return f.fieldName; }), true), [
                wpValue
            ], false);
        }
        else {
            this.workPackets.push(wpValue);
        }
    };
    GeneralService.prototype.getFieldValue = function (str) {
        var _this = this;
        if (str) {
            var separated = str.trim().split(":");
            if (separated.length === 2) {
                if (separated[0] === "L" && this.lineHandling) {
                    return this.lineHandling[separated[1]];
                }
                else if (separated[0] === "NS" && this.lineHandling) {
                    var expression = separated[1];
                    if (expression.indexOf("SUM(quantity)") >= 0) {
                        var sum = this.lineHandling.nominations
                            .map(function (n) { return _this.convertToFloat(n.quantity); })
                            .reduce(function (a, n) { return a + n; });
                        return sum;
                    }
                }
                else if (separated[0] === "N" && this.nomination) {
                    return this.nomination[separated[1]];
                }
            }
        }
        return undefined;
    };
    GeneralService.prototype.replaceMergeField = function (str, surveyor, ordinal, vesselType, truckType) {
        var _a;
        if (surveyor === void 0) { surveyor = undefined; }
        if (ordinal === void 0) { ordinal = 1; }
        if (vesselType === void 0) { vesselType = "Vessel"; }
        if (truckType === void 0) { truckType = 0; }
        if (str.indexOf("{n}") >= 0) {
            return str.replace("{n}", (0, Helper_1.toOrdinalString)(ordinal));
        }
        else if (str.indexOf("{surveyor}") >= 0) {
            surveyor = surveyor === undefined ? "surveyor" : surveyor;
            return str.replace("{surveyor}", surveyor);
        }
        else if (str.indexOf("{vesseltype}") >= 0) {
            return str.replace("{vesseltype}", vesselType);
        }
        else if (str.indexOf("{trucktype}") >= 0) {
            console.log("DWP: truckNomination", this.nomination);
            var truckType_1 = (_a = this.nomination) === null || _a === void 0 ? void 0 : _a.truckType;
            if (truckType_1 !== undefined && truckType_1 === 0) {
                return str.replace("{trucktype}", "Cargo Container");
            }
            else if (truckType_1 !== undefined && truckType_1 === 1) {
                return str.replace("{trucktype}", "ISO Container");
            }
            else {
                return str.replace("{trucktype}", "");
            }
        }
        return str;
    };
    GeneralService.prototype.checkConditionsWithValue = function (str, val) {
        return this.checkConditions(this.replaceAll(str, "value", val));
    };
    GeneralService.prototype.checkConditions = function (str, customData) {
        var _this = this;
        if (str === undefined || str === "")
            return true;
        var conditions = str.split(/\sOR\s|\sAND\s/gm);
        var newStr = str;
        for (var _i = 0, conditions_1 = conditions; _i < conditions_1.length; _i++) {
            var condition = conditions_1[_i];
            var individualResult = false;
            if (condition.trim().startsWith("L:")) {
                if (this.lineHandling === undefined) {
                    individualResult = false;
                }
                else {
                    individualResult =
                        this.lineHandling !== undefined &&
                            this.checkLineHandlingConditions(condition.trim().substr(2));
                }
            }
            else if (condition.trim().startsWith("NS:")) {
                individualResult =
                    this.lineHandling !== undefined &&
                        this.checkNominationsConditions(condition.trim().substr(3));
            }
            else if (condition.trim().startsWith("N:")) {
                if (this.nomination === undefined) {
                    individualResult = false;
                }
                else {
                    individualResult = this.checkNominationConditions(condition.trim().substr(2), this.nomination);
                }
            }
            else if (condition.trim().startsWith("A:")) {
                individualResult = this.checkActivitiesConditions(condition.trim().substr(2), this.activityLogs.filter(function (f) {
                    return _this.nomination === undefined ||
                        f.nominationNo === _this.nomination.nominationNo;
                }));
            }
            else if (condition.trim().startsWith("WP:")) {
                individualResult = this.checkWorkPacketConditions(condition.trim().substring(3), customData);
            }
            else {
                individualResult = false;
            }
            newStr = newStr.replace(condition, " ".concat(individualResult, " "));
        }
        newStr = this.replaceOperators(newStr);
        var result = eval(newStr);
        return result;
    };
    GeneralService.prototype.checkLineHandlingConditions = function (str) {
        if (this.lineHandling === undefined)
            return false;
        var fields = Object.keys(this.lineHandling);
        for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
            var f = fields_1[_i];
            var fieldName = f.substr(0, 1).toUpperCase() + f.substr(1);
            var fieldValue = Reflect.get(this.lineHandling, f);
            if (typeof fieldValue === "number") {
                str = this.replaceAll(str, fieldName, fieldValue.toString());
            }
            else {
                str = this.replaceAll(str, fieldName, "\"".concat(fieldValue, "\""));
            }
        }
        str = this.replaceOperators(str);
        var result = false;
        try {
            result = eval(str);
        }
        catch (_a) { }
        return result;
    };
    GeneralService.prototype.checkNominationsConditions = function (str) {
        if (this.lineHandling === undefined)
            return true;
        var trimmed = str.trim();
        var result = true;
        var regex = /\((.*?)\)/gm;
        var match = [];
        var m;
        while ((m = regex.exec(trimmed.trim())) !== null) {
            if (m.index === regex.lastIndex) {
                regex.lastIndex++;
            }
            m.forEach(function (mat) { return (match = __spreadArray(__spreadArray([], match, true), [mat], false)); });
        }
        if (match.length > 1) {
            var condition = match[1];
            if (condition) {
                if (trimmed.toLowerCase().startsWith("all")) {
                    for (var _i = 0, _a = this.lineHandling.nominations; _i < _a.length; _i++) {
                        var nom = _a[_i];
                        var individualResult = this.checkNominationConditions(condition, nom);
                        if (!individualResult) {
                            result = false;
                            break;
                        }
                    }
                }
                else {
                    for (var _b = 0, _c = this.lineHandling.nominations; _b < _c.length; _b++) {
                        var nom = _c[_b];
                        result = false;
                        var individualResult = this.checkNominationConditions(condition, nom);
                        if (individualResult) {
                            result = true;
                            break;
                        }
                    }
                }
            }
        }
        return result;
    };
    GeneralService.prototype.checkNominationConditions = function (str, nom) {
        var subjectNom = nom !== null && nom !== void 0 ? nom : this.nomination;
        if (subjectNom === undefined)
            return true;
        var fields = Object.keys(subjectNom);
        for (var _i = 0, fields_2 = fields; _i < fields_2.length; _i++) {
            var f = fields_2[_i];
            var fieldName = f.substr(0, 1).toUpperCase() + f.substr(1);
            var fieldValue = Reflect.get(subjectNom, f);
            if (typeof fieldValue === "number")
                str = this.replaceAll(str, "\\b".concat(fieldName, "\\b"), fieldValue.toString());
            else if (fieldValue === undefined)
                str = this.replaceAll(str, "\\b".concat(fieldName, "\\b"), "null");
            else
                str = this.replaceAll(str, "\\b".concat(fieldName, "\\b"), "\"".concat(fieldValue, "\""));
        }
        str = this.replaceOperators(str);
        var result = false;
        try {
            result = eval(str);
        }
        catch (_a) {
            return false;
        }
        return result;
    };
    GeneralService.prototype.checkActivitiesConditions = function (str, activities) {
        var _a;
        var conditions = str.split(/and|or/);
        var funcStatus = (_a = {},
            _a["created"] = 0,
            _a["started"] = 1,
            _a["done"] = 2,
            _a["skipped"] = 3,
            _a["void"] = 4,
            _a["paused"] = 5,
            _a);
        var lastActivities = this.getCurrentActivityPerStep(activities);
        if (lastActivities === undefined)
            return false;
        var _loop_1 = function (condition) {
            var individualResult = false;
            var isLogicalNot = condition.trim().startsWith("!");
            var regex = /\((.*?)\)/gm;
            var match = [];
            var m = void 0;
            while ((m = regex.exec(condition.trim())) !== null) {
                if (m.index === regex.lastIndex) {
                    regex.lastIndex++;
                }
                m.forEach(function (mat) { return (match = __spreadArray(__spreadArray([], match, true), [mat], false)); });
            }
            if (match.length > 1) {
                var stepId_1 = parseInt(match[1]);
                var trimmedCondition = condition.trim().replace("!", "");
                var _loop_2 = function (func) {
                    if (trimmedCondition.startsWith(func)) {
                        var stepActivities = lastActivities.filter(function (f) { return f.processStepId === stepId_1; });
                        if (stepActivities.length > 0) {
                            var maxOrder_1 = stepActivities.sort(function (a, b) { return b.repetitionOrder - a.repetitionOrder; })[0].repetitionOrder;
                            stepActivities = stepActivities.filter(function (f) { return f.repetitionOrder === maxOrder_1; });
                            individualResult = isLogicalNot
                                ? stepActivities.filter(function (f) { return f.status === funcStatus[func]; })
                                    .length > 0
                                : stepActivities.filter(function (f) { return f.status === funcStatus[func]; })
                                    .length === stepActivities.length;
                        }
                        else {
                            individualResult = false;
                        }
                    }
                };
                for (var func in funcStatus) {
                    _loop_2(func);
                }
            }
            individualResult = isLogicalNot ? !individualResult : individualResult;
            str = str.replace(condition, " ".concat(individualResult, " "));
        };
        for (var _i = 0, conditions_2 = conditions; _i < conditions_2.length; _i++) {
            var condition = conditions_2[_i];
            _loop_1(condition);
        }
        str = this.replaceOperators(str);
        var result = eval(str);
        return result;
    };
    GeneralService.prototype.checkWorkPacketConditions = function (str, customData) {
        var operands = str
            .split(/\b(?:eq|neq|and|true|false|gt|lt)\b/gm)
            .filter(function (f) { return f.trim().length > 0; });
        var _loop_3 = function (operand) {
            var field = operand.trim();
            var workPacketVal = void 0;
            if (customData) {
                //get from form / or custom data provided
                workPacketVal = customData.find(function (f) { return f.name === field; });
            }
            else {
                workPacketVal = this_1.workPackets.find(function (f) { return f.fieldName === field; });
            }
            if (workPacketVal) {
                if (customData) {
                    str = this_1.replaceAll(str, field, " \"".concat(workPacketVal.value, "\" "));
                }
                else {
                    if (workPacketVal.valueType === 4) {
                        str = this_1.replaceAll(str, field, workPacketVal.fieldValue);
                    }
                    else if (workPacketVal.valueType === 3 ||
                        workPacketVal.valueType === 2) {
                        str = this_1.replaceAll(str, field, "new Date('".concat(workPacketVal.fieldValue, "')"));
                    }
                    else {
                        str = this_1.replaceAll(str, field, " \"".concat(workPacketVal.fieldValue, "\" "));
                    }
                }
            }
            else {
                str = this_1.replaceAll(str, field, "''");
            }
        };
        var this_1 = this;
        for (var _i = 0, operands_1 = operands; _i < operands_1.length; _i++) {
            var operand = operands_1[_i];
            _loop_3(operand);
        }
        str = this.replaceOperators(str);
        console.log("checkWorkPacketConditions: ", str);
        var result = false;
        try {
            result = eval(str);
        }
        catch (_a) { }
        return result;
    };
    GeneralService.prototype.getCurrentActivityPerStep = function (activityLogs) {
        var result = [];
        var _loop_4 = function () {
            var filter = result.find(function (f) {
                return f.nominationNo === log.nominationNo &&
                    f.processStepId === log.processStepId &&
                    f.surveyor === log.surveyor &&
                    f.repetitionOrder === log.repetitionOrder;
            });
            if (filter) {
                if (log.id > filter.id) {
                    result = __spreadArray(__spreadArray([], result.filter(function (f) { return f.id !== filter.id; }), true), [log], false);
                }
            }
            else {
                result = __spreadArray(__spreadArray([], result, true), [log], false);
            }
        };
        for (var _i = 0, activityLogs_1 = activityLogs; _i < activityLogs_1.length; _i++) {
            var log = activityLogs_1[_i];
            _loop_4();
        }
        result = result.sort(function (a, b) { return a.processStepId - b.processStepId; });
        return result;
    };
    GeneralService.prototype.replaceOperators = function (str) {
        str = this.replaceAll(str, " eq ", " === ");
        str = this.replaceAll(str, " neq ", " !== ");
        str = this.replaceAll(str, " lt ", " < ");
        str = this.replaceAll(str, " gt ", " > ");
        str = this.replaceAll(str, " or ", " || ");
        str = this.replaceAll(str, " OR ", " || ");
        str = this.replaceAll(str, " and ", " && ");
        str = this.replaceAll(str, " AND ", " && ");
        str = this.replaceAll(str, "NULL", "null");
        str = this.replaceAll(str, ".StartsWith", ".startsWith");
        return str;
    };
    GeneralService.prototype.convertToFloat = function (str) {
        str = this.replaceAll(str, "TO", "");
        str = this.replaceAll(str, " ", "");
        str = this.replaceAll(str, ",", "");
        var val = parseFloat(str);
        return isNaN(val) ? 0 : val;
    };
    GeneralService.prototype.replaceAll = function (str, find, newValue) {
        return str.replace(new RegExp(find, "g"), newValue);
    };
    return GeneralService;
}());
exports.GeneralService = GeneralService;
//# sourceMappingURL=GeneralService.js.map